module.exports = __webpack_public_path__ + "img/c.3de5dbfb.jpg";